
import Vue from "vue";
import { SyncManagers } from "../Sync";
import { UserID } from "../Utils";
import { makeJoinLink } from "./Join.vue";
import {s} from "../L10n";

export default Vue.extend({
  props: {
    id: String,
  },
  data() {
    const sync = SyncManagers.get(this.id);
    return {
      sync,
      relayAddress: sync.relayAddress as string,
      key: sync.key as string,
      name: sync.name as string,
      description: sync.description as string,
      participants: sync.participantList as { value: UserID; text: string }[],
      user: sync.user as string | null,
    };
  },
  methods: {
    onClick() {
      this.sync.update(
        this.name,
        this.description,
        this.participants,
        this.user || null
      );
      this.$router.replace({ name: "ledger", params: { id: this.id } });
    },
    onDelete() {
      const msg = s('DELETE_CONFIRM').replace('{0}', this.name);
      const resp = confirm(msg);
      if (!resp) return;
      SyncManagers.del(this.sync);
      this.$router.replace({ name: "list" });
    },
    back() {
      this.$router.replace({ name: "ledger", params: { id: this.id } });
    },
    addParticipant(input: string[]) {
      for (let u of input) {
        if (!this.participants.some(v => v.text == u))
          this.participants.push({ value: crypto.randomUUID(), text: u });
      }
    },
    copyLink() {
      navigator.clipboard.writeText(this.link);
    },
    s(str: string): string {
      return s(str);
    }
  },
  computed: {
    participantsList(): string[] {
      return this.participants.map((x) => x.text);
    },
    link(): string {
      return makeJoinLink(this.sync);
    },
  },
});
